var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7063 6.70664C14.0969 6.31602 14.0969 5.68164 13.7063 5.29102L8.70625 0.291016C8.31563 -0.0996094 7.68125 -0.0996094 7.29063 0.291016C6.9 0.681641 6.9 1.31602 7.29063 1.70664L10.5875 5.00039H1C0.446875 5.00039 0 5.44727 0 6.00039C0 6.55352 0.446875 7.00039 1 7.00039H10.5844L7.29375 10.2941C6.90312 10.6848 6.90312 11.3191 7.29375 11.7098C7.68437 12.1004 8.31875 12.1004 8.70938 11.7098L13.7094 6.70977L13.7063 6.70664Z",
    fill: "#ECEEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.75a26580bedea750863679eef694eb53.svg";
export { ForwardRef as ReactComponent };